export default __webpack_public_path__ + "static/media/Despoiler's Boots of Ushering Twilight.260e41a2.jpg";